export const GET_SETTINGS = 'GET_SETTINGS'
export const ERROR_STATE = 'ERROR_STATE'
